import { EDI_RFID_AUDIT_REQUEST_CREATE_REQUEST, EDI_RFID_AUDIT_REQUEST_CREATE_SUCCESS, EDI_RFID_AUDIT_REQUEST_CREATE_FAILURE } from './types/EdiRfidAuditRequestCreateActionsTypes';

export function postEdiRfidAuditCreateRequestActionCreator(selectedAuditName,
                                                           selectedExecutionMoment,
                                                           selectedInboundImpcs,
                                                           selectedOutboundImpcs,
                                                           selectedReportingEndDate,
                                                           selectedReportingStartDate,
                                                           selectedScheduleFrequency,
                                                           selectedScheduleType,
                                                           selectedScheduledEndDate,
                                                           selectedScheduledStartDate) {
  return {
    type: EDI_RFID_AUDIT_REQUEST_CREATE_REQUEST,
    payload: {
      params: {
        auditName: selectedAuditName,
        executionMoment: selectedExecutionMoment,
        inboundImpcs: selectedInboundImpcs,
        outboundImpcs: selectedOutboundImpcs,
        reportingEndDate: selectedReportingEndDate,
        reportingStartDate: selectedReportingStartDate,
        scheduleFrequency: selectedScheduleFrequency,
        scheduleType: selectedScheduleType,
        scheduledEndDate: selectedScheduledEndDate,
        scheduledStartDate: selectedScheduledStartDate,
      },
    },
  };
}

export function postEdiRfidAuditCreateSuccessActionCreator(data) {
  return {
    type: EDI_RFID_AUDIT_REQUEST_CREATE_SUCCESS,
    payload: data,
  };
}

export function postEdiRfidAuditCreateFailureActionCreator(error) {
  return {
    type: EDI_RFID_AUDIT_REQUEST_CREATE_FAILURE,
    payload: error,
    error: true,
  };
}
